import { bem } from 'mission-control-common-components';

import { OrderOption } from '../../../../../../apis/graphql';
import SortArrow from '../../../../../../common/SortArrow';
import { REPORT_LIST_HEADER_COLUMNS } from '../../constants';

const [, element] = bem('custom-pacing-report-list');

type Props = { sortOrder: OrderOption; onToggleSortOrder: () => void };

const ReportListTableHeader = ({ sortOrder, onToggleSortOrder }: Props): React.JSX.Element => (
  <thead>
    <tr>
      <th className={element('col', 'name')}>{REPORT_LIST_HEADER_COLUMNS.name}</th>
      <th className={element('col', 'create-date')}>
        {REPORT_LIST_HEADER_COLUMNS.createDate}
        <SortArrow
          isSorted
          isDescending={sortOrder === OrderOption.Desc}
          onClick={onToggleSortOrder}
          data-testid="sort-arrow"
        />
      </th>
      <th className={element('col', 'user-created')}>{REPORT_LIST_HEADER_COLUMNS.userCreated}</th>
      <th className={element('col', 'download')}>{REPORT_LIST_HEADER_COLUMNS.download}</th>
    </tr>
  </thead>
);

export default ReportListTableHeader;
